import React from "react";
import fondoHeader from "../../assets/image/stella/reseller_header.jpg";
import fondobanner from "../../assets/image/stella/reventa_fondo.jpg";
import imagen from "../../assets/image/stella/installsmartv1.png";

function Section1({data}) {

    return (
        <>
            <div className="h-[128px] bg-no-repeat opacity-50 -z-10"
                 style={{
                     backgroundImage: `linear-gradient(180deg, #00000085, #141414), url(${fondoHeader})`,
                 }}></div>
            <section className="relative" id="inicio">
                <div
                    className="absolute inset-0  bg-repeat-y opacity-50 z-0"
                    style={{
                        backgroundImage: `linear-gradient(180deg, #00000085, #141414), url(${fondobanner})`,
                    }}></div>
                <div
                    className="relative container z-10 px-4 py-12 md:py-20 grid grid-cols-1 md:grid-cols-2 max-md:gap-10 items-center">
                    <img alt="reventa magis tv app" width="545" height="536" decoding="async" data-nimg="1"
                         className="h-auto w-full max-w-[460px] filter-[brightness(111%)_contrast(95%)_saturate(85%)_blur(0px)_hue-rotate(160deg)]"
                         src={imagen}/>
                    <div className="text-center text-white">
                        <h2 className="mt-4 font-bold uppercase text-white hover:text-[#eeb500]">Stella TV para smart
                            tv</h2>
                        <p className="mt-4 text-base leading-relaxed">Aquí puede descargar e instalar Stella TV en un
                            smart tv con sistema Android TV como: <span
                                className="text-active">Xiaomi, Sony Bravia, Hisense, JVC, etc. </span> (No se puede en
                            smart tv sin Android como LG ó Samsung)</p>
                        <div className="mt-10 grid md:grid-cols-2 gap-3 md:justify-center">
                            <a href={data.tv_url}
                               rel="nofollow"
                               className="btn-outline inline-flex gap-1 px-0 py-2.5 h-[44px] justify-center no-underline hover:text-[#eeb500]"
                               download=""><span>DESCARGAR</span></a>
                            <a href={data.tv_url} rel="nofollow"
                               className="btn-primary inline-flex gap-1 px-0 py-2.5 h-[44px] justify-center no-underline "
                               download=""><span>OPCIÓN #2</span></a></div>
                        <div className="mt-5"><p>Códigos Downloader: <strong className="text-[#ff6600]">{data.code}</strong>
                        </p></div>
                    </div>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none"
                     className="absolute bottom-0 left-0 w-full h-[54px] rotate-180">
                    <path opacity="0.33"
                          d="M473,67.3c-203.9,88.3-263.1-34-320.3,0C66,119.1,0,59.7,0,59.7V0h1000v59.7 c0,0-62.1,26.1-94.9,29.3c-32.8,3.3-62.8-12.3-75.8-22.1C806,49.6,745.3,8.7,694.9,4.7S492.4,59,473,67.3z"></path>
                    <path opacity="0.66"
                          d="M734,67.3c-45.5,0-77.2-23.2-129.1-39.1c-28.6-8.7-150.3-10.1-254,39.1 s-91.7-34.4-149.2,0C115.7,118.3,0,39.8,0,39.8V0h1000v36.5c0,0-28.2-18.5-92.1-18.5C810.2,18.1,775.7,67.3,734,67.3z"></path>
                    <path
                        d="M766.1,28.9c-200-57.5-266,65.5-395.1,19.5C242,1.8,242,5.4,184.8,20.6C128,35.8,132.3,44.9,89.9,52.5C28.6,63.7,0,0,0,0 h1000c0,0-9.9,40.9-83.6,48.1S829.6,47,766.1,28.9z"></path>
                </svg>
            </section>
        </>
    );
}

export default Section1;
